import React from 'react';
import '../assets/styles/home.css';
import SEOHelmet from '../components/common/SEOHelmet';

const Home = () => {
  return (
    <>
      <SEOHelmet
        title="Matrix IT - IT Solutions Provider in Cuttack, Odisha"
        description="Matrix IT provides comprehensive IT solutions including laptop & desktop sales, server infrastructure, networking, AMC, and cybersecurity services in Cuttack, Odisha. Ensuring seamless, secure, and efficient IT operations for businesses."
        keywords="IT solutions Cuttack, IT services Odisha, laptop sales, desktop sales, server infrastructure, networking, AMC, cybersecurity, IT support Cuttack"
        canonicalUrl="https://www.matrixit.co.in"
      />
      <div className="home-page">
        <section className="hero">
          <div className="hero-content">
            <h1>Welcome to Matrix IT</h1>
            <p>Your Trusted IT Solutions Provider in Cuttack, Odisha</p>
            <p className="hero-subtitle">Ensuring seamless, secure, and efficient IT operations for businesses of all sizes</p>
            <button className="hero-button">Discover More</button>
          </div>
          <div className="hero-overlay"></div>
        </section>

        <section className="features">
          <h2>Why Choose Matrix IT</h2>
          <div className="feature-grid">
            <div className="feature-card" data-animate="fade-up">
              <div className="feature-icon">💻</div>
              <h3>Technical Expertise & Innovation</h3>
              <p>Staying updated with the latest tech trends</p>
              <p className="feature-detail">Cutting-edge solutions tailored to your business needs</p>
            </div>
            <div className="feature-card" data-animate="fade-up" data-delay="200">
              <div className="feature-icon">🤝</div>
              <h3>Customer-Centric Approach</h3>
              <p>Tailored solutions and personalized support</p>
              <p className="feature-detail">Understanding your unique requirements and delivering excellence</p>
            </div>
            <div className="feature-card" data-animate="fade-up" data-delay="400">
              <div className="feature-icon">⚡</div>
              <h3>Reliability & Uptime Assurance</h3>
              <p>Minimizing downtime through proactive maintenance</p>
              <p className="feature-detail">24/7 monitoring and rapid response to keep you running</p>
            </div>
            <div className="feature-card" data-animate="fade-up" data-delay="600">
              <div className="feature-icon">💰</div>
              <h3>Cost-Effective & Scalable</h3>
              <p>Solutions that grow with your business</p>
              <p className="feature-detail">Optimized IT investments for maximum ROI</p>
            </div>
          </div>
        </section>

        <section className="stats">
          <div className="stats-grid">
            <div className="stat-item" data-animate="count-up">
              <h3>100+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item" data-animate="count-up" data-delay="200">
              <h3>99%</h3>
              <p>Uptime Guarantee</p>
            </div>
            <div className="stat-item" data-animate="count-up" data-delay="400">
              <h3>15+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </section>

        <section className="cta">
          <div className="cta-content" data-animate="fade-in">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's work together to bring your vision to life</p>
            <p className="cta-subtitle">Contact us for a free consultation today</p>
            <button className="cta-button">Get Started Now</button>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;